// extracted by mini-css-extract-plugin
export var highlightFade = "_2s-4";
export var highlighted = "_2s-3";
export var table = "_2s-1";
export var tableContainer = "_2s-0";
export var totalsRow = "_2s-2";